import { render } from "./EventDisplay.vue?vue&type=template&id=5907ff5a"
import script from "./EventDisplay.vue?vue&type=script&lang=js"
export * from "./EventDisplay.vue?vue&type=script&lang=js"

import "./EventDisplay.vue?vue&type=style&index=0&id=5907ff5a&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__